import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axiosInstance";

const API_BASE_URL = "/api/v1/conference";

// Thunks
export const fetchConferences = createAsyncThunk(
  "conference/fetchAll",
  async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}`);
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

export const createConference = createAsyncThunk(
  "conference/create",
  async (data) => {
    const response = await axios.post(`${API_BASE_URL}`, data);
    return response.data.data;
  }
);

export const updateConference = createAsyncThunk(
  "conference/update",
  async ({ id, data }) => {
    const response = await axios.put(`${API_BASE_URL}/${id}`, data);
    return response.data.data;
  }
);

export const deleteConference = createAsyncThunk(
  "conference/delete",
  async (id) => {
    await axios.delete(`${API_BASE_URL}/${id}`);
    return id;
  }
);

// Fetch by ID
export const fetchConferenceById = createAsyncThunk(
  'conference/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (err) {
      // Extract error message

      const message =
        err.response?.data?.message || err.message || 'Something went wrong';
      return rejectWithValue(message);
    }
  }
);


// Slice
const conferenceSlice = createSlice({
  name: "conference",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchConferences.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConferences.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchConferences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createConference.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createConference.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(createConference.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Update
      .addCase(updateConference.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateConference.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.list.findIndex((c) => c._id === action.payload._id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(updateConference.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Delete
      .addCase(deleteConference.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteConference.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter((c) => c._id !== action.payload);
      })
      .addCase(deleteConference.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
       //fetch Conference  By  Id
      .addCase(fetchConferenceById.fulfilled, (state, action) => {
        state.current = action.payload.data;
        state.loading = false;
      }).addCase(fetchConferenceById.pending, (state) => {
        state.loading = true;
      }).addCase(fetchConferenceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch conference';
      });
  },
});

export default conferenceSlice.reducer;
